module.exports = __webpack_public_path__ + "static/TownOfLight3-1ff3366e0cc2ecb008edf66b09234c1c.png";